import { isPlatformBrowser } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';

/**
 * LocalStorage is wrapper class for localStorage, operations can fail due to various reasons,
 * such as browser restrictions or storage limits being exceeded. A wrapper is providing error handling.
 */
class SessionStorage implements Storage {
    get length(): number {
        try {
            return sessionStorage.length;
        } catch {
            return 0;
        }
    }

    clear(): void {
        try {
            sessionStorage.clear();
        } catch {
            /* Empty */
        }
    }

    getItem(key: string): string | null {
        try {
            return sessionStorage.getItem(key);
        } catch {
            return null;
        }
    }

    key(index: number): string | null {
        try {
            return sessionStorage.key(index);
        } catch {
            return null;
        }
    }

    removeItem(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch {
            /* Empty */
        }
    }

    setItem(key: string, value: string): void {
        try {
            sessionStorage.setItem(key, value);
        } catch {
            /* Empty */
        }
    }
}

const getStorage = (platformId: object): Storage | null =>
    isPlatformBrowser(platformId) ? sessionStorage : null;

export const SESSION_STORAGE = new InjectionToken<Storage | null>('SESSION_STORAGE', {
    providedIn: 'root',
    factory: () => getStorage(inject(PLATFORM_ID)),
});